const en = {
  meta: {
    title: "Nexora Technologies — The European AI Transformation Partner",
  },
  nav: {
    home: "Home",
    services: "Services",
    aiTransformation: "AI Transformation",
    industries: "Industries",
    about: "About",
    contact: "Contact",
    countries: "Countries",
    bookStrategy: "Book a Strategy Session",
  },
  countriesNav: {
    netherlands: "Netherlands",
    germany: "Germany",
    switzerland: "Switzerland",
    belgium: "Belgium",
    "united-kingdom": "United Kingdom",
  },
  langSwitcher: {
    label: "Language",
  },
  hero: {
    eyebrow: "The European AI Transformation Partner",
    title1: "Scale faster.",
    title2: "Access world-class technology talent.",
    subtitle:
      "Nexora Technologies helps European organisations solve technology talent shortages through nearshore delivery and AI transformation.",
    bookDiscovery: "Book a Discovery Call",
    requestTalent: "Request Technology Talent",
  },
  trustStats: [
    { value: "20+", label: "Years of international delivery" },
    { value: "5", label: "European markets served" },
    { value: "500+", label: "Specialists deployed" },
    { value: "<1h", label: "Average response time" },
  ],
  whyUs: {
    eyebrow: "why nexora",
    title: "Technology is evolving faster than organisations can hire.",
    lede:
      "Finding experienced AI Engineers, Cloud Architects, SAP Consultants and Cybersecurity Specialists has become one of the biggest challenges across Europe.",
    body1:
      "Nexora gives organisations immediate access to highly skilled technology professionals through a flexible nearshore delivery model with minimal time difference — enabling seamless collaboration with internal teams.",
    body2:
      "For more than 20 years we have successfully delivered outsourcing, insourcing and digital transformation programmes for international clients.",
    aboutLink: "About Nexora",
    deliverablesEyebrow: "what we deliver",
  },
  deliverables: [
    "AI Engineers",
    "Generative AI Specialists",
    "Machine Learning Engineers",
    "Cloud Engineers",
    "Cybersecurity Experts",
    "DevOps Engineers",
    "Data Engineers",
    "SAP Consultants",
    "Software Development Teams",
    "Technology Transformation Consulting",
  ],
  servicesSection: {
    eyebrow: "services",
    title: "An enterprise platform of capability — delivered as one.",
    lede:
      "From AI Centres of Excellence to dedicated nearshore engineering pods, our services combine to scale your technology execution.",
  },
  services: [
    {
      slug: "ai-transformation",
      title: "AI Transformation",
      summary:
        "Identify, design and operationalise AI use cases with measurable business value — from strategy to deployment.",
      bullets: ["AI Strategy & Roadmap", "Generative AI Solutions", "AI Governance", "AI Centre of Excellence"],
    },
    {
      slug: "dedicated-teams",
      title: "Dedicated Engineering Teams",
      summary:
        "Senior nearshore engineering pods that plug directly into your delivery — same time zone, European standards.",
      bullets: ["Pod-based delivery", "Senior-led teams", "Transparent governance", "Flexible scaling"],
    },
    {
      slug: "cloud",
      title: "Cloud Engineering",
      summary:
        "Azure, AWS and GCP architecture, migration and FinOps — built for European compliance and resilience.",
      bullets: ["Landing zones", "Cloud migration", "Platform engineering", "FinOps"],
    },
    {
      slug: "cybersecurity",
      title: "Cybersecurity",
      summary: "From zero-trust architecture to OT security — protect your enterprise across every layer.",
      bullets: ["Zero-trust design", "Cloud security", "Identity & access", "OT / IoT security"],
    },
    {
      slug: "sap",
      title: "SAP & Enterprise Platforms",
      summary:
        "S/4HANA, BTP and enterprise modernisation programmes delivered by certified senior consultants.",
      bullets: ["S/4HANA migration", "BTP development", "Integration", "Managed services"],
    },
    {
      slug: "software-engineering",
      title: "Software Engineering",
      summary:
        "Full-lifecycle product engineering — discovery, design, build and modernise — with European quality.",
      bullets: ["Product engineering", "Platform modernisation", "QA & DevOps", "API platforms"],
    },
  ],
  countriesSection: {
    eyebrow: "our markets",
    title: "Built for European delivery.",
    lede:
      "Senior-led pods operating in your time zone, with local market insight in five core European countries.",
    exploreLabel: "Explore",
  },
  aiFeature: {
    eyebrow: "ai transformation",
    title: "Artificial Intelligence is no longer a future initiative.",
    lede:
      "It has become a competitive necessity. Nexora helps organisations identify, design and implement AI solutions that create measurable business value.",
    tags: ["AI Strategy", "Generative AI", "AI Governance", "AI Centre of Excellence"],
    exploreLink: "Explore AI Transformation services",
  },
  principles: {
    eyebrow: "how we operate",
    title: "Built for European enterprise.",
    lede: "Our delivery model is engineered for transparency, governance and senior-led outcomes.",
    items: [
      {
        title: "Senior-led engagements",
        desc: "Every programme is led by senior engineers and advisors — not junior resources behind a brand.",
      },
      {
        title: "European standards",
        desc:
          "GDPR-native delivery, EU AI Act-aligned governance and a nearshore model in the same business hours.",
      },
      {
        title: "Outcome over hours",
        desc:
          "We commit to measurable outcomes, not just timesheets. Our pods are accountable end-to-end.",
      },
      {
        title: "Transparent governance",
        desc:
          "Open delivery dashboards, weekly steering rituals, full visibility into velocity and risk.",
      },
    ],
  },
  finalCta: {
    eyebrow: "next step",
    heading: "Let's Build Your Competitive Advantage.",
    lede:
      "Talk to a senior Nexora strategist. We'll map the highest-impact technology and AI moves for your organisation — in one call.",
    button: "Book a Strategy Session",
    exploreBtn: "Explore our services",
  },
  leadForm: {
    stepLabels: ["Country", "Skills", "Team size", "Duration", "Your details"],
    country: {
      title: "Which country?",
      lede: "Choose where you need senior technology talent.",
    },
    skills: {
      title: "Which skills are you looking for?",
      lede: "Pick all that apply. You can mix specialists or describe a full team.",
    },
    teamSize: {
      title: "How large should the team be?",
      lede: "We can scale from a single senior specialist to a full pod.",
    },
    duration: {
      title: "How long is the engagement?",
      lede: "Most engagements start at 3 months and extend based on outcomes.",
    },
    details: {
      title: "Your details",
      lede: "We'll route your request to the right senior strategist.",
      name: "Full name",
      email: "Work email",
      company: "Company",
      message: "What are you trying to achieve? (optional)",
      namePh: "Jane van Berg",
      emailPh: "jane@company.eu",
      companyPh: "Your organisation",
      messagePh: "Briefly describe your initiative, timelines and any constraints.",
    },
    back: "Back",
    next: "Continue",
    send: "Send request",
    sending: "Sending…",
    successTitle: "Request received.",
    successLede:
      "Thank you. A senior Nexora strategist will reach out within one business day to schedule your discovery call.",
    errorGeneric: "Something went wrong. Please try again.",
    toastSuccessTitle: "Request received",
    toastSuccessDesc: "A Nexora strategist will contact you within one business day.",
    toastErrorTitle: "Could not submit",
  },
  skills: {
    "ai-engineers": "AI Engineers",
    "generative-ai": "Generative AI Specialists",
    "ml-engineers": "Machine Learning Engineers",
    mlops: "MLOps Engineers",
    "data-engineers": "Data Engineers",
    "data-scientists": "Data Scientists",
    "cloud-engineers": "Cloud Engineers (Azure / AWS / GCP)",
    "cloud-architects": "Cloud Architects",
    devops: "DevOps Engineers",
    cybersecurity: "Cybersecurity Specialists",
    sap: "SAP Consultants",
    "software-dev": "Software Development Teams",
    java: "Java Developers",
    dotnet: ".NET Developers",
    python: "Python Developers",
    fullstack: "Full Stack Developers",
    "power-platform": "Microsoft Power Platform",
    salesforce: "Salesforce Consultants",
    transformation: "Technology Transformation Consulting",
  },
  teamSizes: {
    "1-3": "1 – 3 specialists",
    "4-6": "4 – 6 specialists",
    "7-10": "7 – 10 specialists",
    "10-plus": "10+ specialists",
  },
  durations: {
    "3m": "3 months",
    "6m": "6 months",
    "12m": "12 months",
    ongoing: "Ongoing partnership",
  },
  contactPage: {
    eyebrow: "Book a Strategy Session",
    title1: "Let's Build Your",
    title2: "Competitive Advantage.",
    lede:
      "Tell us about the technology talent or AI transformation initiative you're scoping. A senior Nexora strategist will reach out within one business day.",
    directHeading: "direct",
    addressList: "Amsterdam · Frankfurt · Zurich · Brussels · London",
    whatToExpectHeading: "what to expect",
    whatToExpectList: [
      "Response within one business day",
      "Discovery call with a senior strategist",
      "Tailored capability proposal in <5 days",
      "No commitment, full confidentiality",
    ],
  },
  aboutPage: {
    eyebrow: "About",
    title1: "The European AI",
    title2: "Transformation Partner.",
    lede:
      "Nexora Technologies helps European organisations scale technology capability through AI transformation, scarce technology talent and dedicated nearshore engineering teams.",
    missionEyebrow: "our mission",
    missionTitle: "To help European enterprise compete in the age of AI.",
    missionPara1:
      "For more than 20 years we have delivered outsourcing, insourcing and digital transformation programmes for international clients. Today we are focused on a single mission: helping European organisations win in the age of AI.",
    missionPara2:
      "We combine scarce technology talent, a governed nearshore delivery model and deep AI expertise to give our clients the speed of execution that modern competition demands.",
    missionList: [
      "Trusted by international enterprise across five core European markets",
      "Senior-led pods — never junior resources behind a brand",
      "Outcome-based engagements with transparent governance",
      "AI-native delivery, GDPR-native by design",
    ],
  },
  servicesPage: {
    eyebrow: "Services",
    title1: "An enterprise platform",
    title2: "of technology capability.",
    lede:
      "Six interconnected services — combined into a single, governed delivery model that scales technology execution for European enterprise.",
    talkLink: "Talk to an advisor",
  },
  industriesPage: {
    eyebrow: "Industries",
    title1: "Built for the industries",
    title2: "where technology decides who wins.",
    lede:
      "Sector-specific delivery teams that understand the dynamics, regulations and competitive realities of your industry.",
    talkLink: "Talk to us",
  },
  industries: [
    { slug: "financial-services", title: "Financial Services", desc: "Banking, insurance and capital markets." },
    { slug: "government", title: "Government & Public Sector", desc: "Digital public services and sovereign cloud." },
    { slug: "healthcare", title: "Healthcare & Life Sciences", desc: "Clinical, research and pharma transformation." },
    { slug: "energy", title: "Energy & Utilities", desc: "Energy transition, grid intelligence, OT security." },
    { slug: "manufacturing", title: "Manufacturing", desc: "Industry 4.0, smart factories, supply chain AI." },
    { slug: "retail", title: "Retail & E-commerce", desc: "Omnichannel, personalisation and demand AI." },
    { slug: "logistics", title: "Logistics & Transport", desc: "Networks, routing intelligence and digital twins." },
    { slug: "telecom", title: "Telecommunications", desc: "Network modernisation and customer AI." },
  ],
  aiPage: {
    eyebrow: "AI Transformation",
    title1: "Artificial Intelligence",
    title2: "is no longer a future initiative.",
    lede:
      "It has become a competitive necessity. Nexora Technologies helps organisations identify, design and implement AI solutions that create measurable business value.",
    startBtn: "Start your AI Readiness Assessment",
    allServicesBtn: "See all services",
    servicesEyebrow: "AI services",
    servicesTitle: "A complete AI delivery capability.",
    servicesLede:
      "From advisory and governance to engineering and operations — Nexora delivers AI as a managed, accountable capability.",
    approachEyebrow: "our approach",
    approachTitle: "From strategy to scale, in four governed phases.",
    approachLede:
      "Nexora moves AI from ambition to enterprise-grade outcomes — without the typical PoC graveyard.",
    talkLink: "Talk to an AI advisor",
    services: [
      { title: "AI Strategy", desc: "Define the highest-value AI initiatives aligned to your business strategy." },
      { title: "AI Readiness Assessment", desc: "Evaluate data, talent, infrastructure and governance readiness." },
      { title: "AI Governance", desc: "Operate AI responsibly with policies, controls and EU AI Act alignment." },
      { title: "AI Factory Advisory", desc: "Design a repeatable delivery model that scales AI from PoC to production." },
      { title: "Generative AI Solutions", desc: "Build copilots, agents and knowledge systems on your enterprise data." },
      { title: "AI Automation", desc: "Automate complex workflows by combining LLMs, RPA and process intelligence." },
      { title: "AI Integration", desc: "Integrate AI into your core systems — CRM, ERP, data platforms and beyond." },
      { title: "AI Infrastructure Advisory", desc: "Architect GPU, MLOps and platform foundations for production AI." },
      { title: "AI Training", desc: "Upskill leaders and engineers with role-based AI programmes." },
      { title: "AI Centre of Excellence", desc: "Stand up a CoE that orchestrates AI value across the enterprise." },
    ],
    phases: [
      { step: "01", title: "Diagnose", desc: "AI readiness, value map and governance baseline." },
      { step: "02", title: "Design", desc: "Solution architecture, data foundations, target operating model." },
      { step: "03", title: "Deliver", desc: "Build, integrate and operationalise with senior-led pods." },
      { step: "04", title: "Scale", desc: "AI CoE, MLOps, model lifecycle and value tracking." },
    ],
  },
  notFound: {
    eyebrow: "404",
    title: "Page not found.",
    body: "The page you're looking for doesn't exist — but we'd still love to talk.",
    backBtn: "Back to home",
  },
  country: {
    common: {
      specialistsEyebrow: "most requested",
      specialistsTitle: "Most Requested Specialists",
      specialistsLede: "Roles where demand outpaces supply — and where Nexora delivers fastest.",
      industriesEyebrow: "industries",
      industriesTitle: "Industries we serve",
      whyEyebrow: "why nexora",
      whyTitle: "Why teams choose Nexora",
      formEyebrow: "request talent",
      formTitle: "Let's Build Your Competitive Advantage.",
      formLede: "Tell us which profiles you need — we'll respond within one business day.",
      formCta: "Request Technology Talent",
      exploreLabel: "Explore services",
      finalHeading: "Let's Build Your Competitive Advantage.",
      finalCta: "Book a Strategy Session",
      bullets: [
        "Senior-led teams · nearshore delivery",
        "European quality, GDPR-native",
        "Rapid onboarding · flexible scaling",
      ],
    },
    netherlands: {
      eyebrow: "Netherlands",
      title: "Technology Talent for the Netherlands",
      lede:
        "The Dutch technology market is growing faster than available talent. We help organisations rapidly scale their technology teams with highly experienced professionals working in almost the same time zone.",
      body:
        "Whether you are building AI solutions, migrating to Azure, modernising SAP or strengthening your cybersecurity posture, we provide the right specialists exactly when you need them.",
      specialists: [
        "AI Engineers",
        "Azure Cloud Engineers",
        "Cybersecurity Specialists",
        "DevOps Engineers",
        "Data Engineers",
        "Microsoft Power Platform Specialists",
        "SAP Consultants",
        "Java Developers",
        "Full Stack Developers",
        "Data Analysts",
      ],
      industries: ["Financial Services", "Government", "Healthcare", "Energy", "Logistics", "Retail", "Manufacturing"],
      whyUs: [
        "Nearshore collaboration",
        "Minimal time difference",
        "Rapid onboarding",
        "Dedicated teams",
        "Flexible scaling",
        "20+ years international delivery experience",
      ],
    },
    germany: {
      eyebrow: "Germany",
      title: "Technology Specialists for the German market",
      lede:
        "The skills shortage doesn't need to slow your growth. Our nearshore teams integrate seamlessly into your organisation and deliver the highest quality.",
      body:
        "Whether AI, cloud migration, SAP modernisation or cybersecurity — we deliver the right experts exactly when you need them.",
      specialists: [
        "SAP S/4HANA Consultants",
        "AI Engineers",
        "Cybersecurity Specialists",
        "Cloud Architects",
        "DevOps Engineers",
        "Embedded Software Engineers",
        "Data Engineers",
        "Java Developers",
        "Platform Engineers",
        "OT Security Specialists",
      ],
      industries: ["Automotive", "Manufacturing", "Finance", "Healthcare", "Energy", "Government"],
      whyUs: [
        "Nearshore collaboration",
        "Minimal time difference",
        "Rapid onboarding",
        "Dedicated teams",
        "Flexible scaling",
        "20+ years of international experience",
      ],
    },
    switzerland: {
      eyebrow: "Switzerland",
      title: "Technology Excellence for Switzerland",
      lede:
        "Swiss organisations demand world-class technology expertise. Our specialists deliver enterprise-grade solutions while collaborating in almost identical business hours.",
      body:
        "From private banking to pharmaceutical R&D, we deliver the senior technologists Swiss enterprises rely on.",
      specialists: [
        "AI Engineers",
        "Quant Developers",
        "Cloud Security Engineers",
        "Cybersecurity Specialists",
        "Azure Architects",
        "DevSecOps Engineers",
        "Data Engineers",
        "MLOps Engineers",
        "Software Architects",
        "Blockchain Engineers",
      ],
      industries: ["Banking", "Insurance", "Life Sciences", "Pharmaceuticals", "Healthcare", "Manufacturing"],
      whyUs: [
        "Senior-led teams",
        "Swiss-grade quality",
        "Same-day collaboration",
        "Sovereign data handling",
        "Regulated industry experience",
        "20+ years international delivery experience",
      ],
    },
    belgium: {
      eyebrow: "Belgium",
      title: "Technology Talent that Accelerates Innovation",
      lede:
        "Finding experienced IT professionals has never been more difficult. Our nearshore teams provide immediate capacity while maintaining European quality standards.",
      body:
        "From the European institutions in Brussels to financial services and life sciences — Nexora delivers across Belgium's most demanding sectors.",
      specialists: [
        "Azure Engineers",
        "SAP Consultants",
        "Cybersecurity Specialists",
        "Data Engineers",
        "Java Developers",
        ".NET Developers",
        "DevOps Engineers",
        "AI Engineers",
        "Business Intelligence Specialists",
        "Cloud Operations Engineers",
      ],
      industries: ["European Institutions", "Financial Services", "Chemicals", "Logistics", "Healthcare", "Government"],
      whyUs: [
        "Bilingual collaboration",
        "EU-grade compliance",
        "Senior delivery teams",
        "Flexible scaling",
        "Brussels & Antwerp focus",
        "20+ years international delivery experience",
      ],
    },
    "united-kingdom": {
      eyebrow: "United Kingdom",
      title: "World-Class Technology Talent for UK Organisations",
      lede:
        "Scale faster with highly experienced technology specialists. We provide dedicated engineering teams with minimal time difference and seamless collaboration.",
      body:
        "From FinTech in London to defence and energy programmes nationwide — Nexora delivers senior-led engineering teams at UK quality bar.",
      specialists: [
        "AI Engineers",
        "Cybersecurity Specialists",
        "Cloud Engineers",
        "DevOps Engineers",
        "Data Scientists",
        "Python Developers",
        "Java Developers",
        "Salesforce Consultants",
        "AWS Architects",
        "Platform Engineers",
      ],
      industries: ["Financial Services", "FinTech", "Healthcare", "Retail", "Defence", "Energy", "Telecommunications"],
      whyUs: [
        "Same-day collaboration",
        "Senior-led pods",
        "UK quality standards",
        "Rapid onboarding",
        "Flexible scaling",
        "20+ years international delivery experience",
      ],
    },
  },
  footer: {
    tagline:
      "The European AI Transformation Partner. We help European organisations scale technology capability through AI transformation, scarce technology talent and dedicated nearshore engineering teams.",
    company: "Company",
    servicesCol: "Services",
    countriesCol: "Countries",
    about: "About",
    whyNexora: "Why Nexora",
    contact: "Contact",
    aiTransformation: "AI Transformation",
    servicesOverview: "Services overview",
    industries: "Industries",
    privacy: "Privacy",
    terms: "Terms",
    cookies: "Cookies",
    copyright: "All rights reserved.",
    address: "Amsterdam · Frankfurt · Zurich · Brussels · London",
  },
  brandTagline: "The European AI Transformation Partner",
};

export default en;
